import { render } from "./PublishSettingsModal.vue?vue&type=template&id=28d2d6f5&scoped=true"
import script from "./PublishSettingsModal.vue?vue&type=script&lang=js"
export * from "./PublishSettingsModal.vue?vue&type=script&lang=js"

import "./PublishSettingsModal.vue?vue&type=style&index=0&id=28d2d6f5&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28d2d6f5"]])

export default __exports__